import { render, staticRenderFns } from "./QuestionnaireCompletedEmailTemplate.vue?vue&type=template&id=22e5e001&scoped=true"
import script from "./QuestionnaireCompletedEmailTemplate.vue?vue&type=script&lang=js"
export * from "./QuestionnaireCompletedEmailTemplate.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireCompletedEmailTemplate.vue?vue&type=style&index=0&id=22e5e001&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e5e001",
  null
  
)

export default component.exports